import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import useKeyDownListener from 'hooks/useKeyDownListener';
import ListBulletIcon from 'images/v5/icons/align-justify.svg';
import CheckSvg from 'images/v5/icons/check.svg';
import Button from 'layout/atoms/Button/Button';
import Checkbox from 'layout/atoms/Checkbox/Checkbox';
import Label from 'layout/atoms/Label';
import Modal from 'layout/atoms/Modal/Modal';
import Grid from 'layout/molecules/Grid/Grid';
import { closeModal } from 'store/layoutSlice';
import { activateSize, deactivateSize, selectProductionQuantitiesItem, } from 'store/specificationProductionQuantitiesSlice';
function SizesEditor() {
    const { t } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    const productionQuantitiesItem = useSelector(selectProductionQuantitiesItem);
    const sizes = productionQuantitiesItem === null || productionQuantitiesItem === void 0 ? void 0 : productionQuantitiesItem.sizes;
    useKeyDownListener([
        { code: 'Enter', callback: () => dispatch(closeModal({ name: 'sizesEditor' })) },
        { code: 'Escape', callback: () => dispatch(closeModal({ name: 'sizesEditor' })) },
    ]);
    const handleSizeActivation = (id, isActive) => {
        if (isActive) {
            dispatch(deactivateSize({ specificationSizeId: id }));
        }
        else {
            dispatch(activateSize({ specificationSizeId: id }));
        }
    };
    return (React.createElement(Modal, { name: "sizesEditor", size: "xs", header: React.createElement(Label, { weight: "strong" },
            React.createElement(ListBulletIcon, null),
            t('edit_sizes')), footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { theme: "ghost", onClick: () => dispatch(closeModal({ name: 'sizesEditor' })) }, t('cancel')),
            React.createElement(Button, { color: "primary", leftIcon: React.createElement(CheckSvg, null), onClick: () => dispatch(closeModal({ name: 'sizesEditor' })) }, t('common:done'))) },
        React.createElement(Grid, { gap: 12 }, sizes.map((size) => size && (React.createElement(Checkbox, { key: size.id, label: size.sizeName.name, value: size.isActive, onClick: () => handleSizeActivation(size.id, size.isActive) }))))));
}
export default memo(SizesEditor);
